module.exports = "\n\nul {\n  list-style-type: none;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  background-color: #333;\n  position: fixed;\n  top: 0;\n  width: 100%;\n  left: 0px;\n}\n\nli {\n  float: left;\n}\n\nli a {\n  display: block;\n  color: white;\n  text-align: center;\n  padding: 14px 16px;\n  text-decoration: none;\n}\n\nli a:hover:not(.active) {\n  background-color: #494A4B;\n}\n\n.active {\n    background-color: cadetblue;\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/navbar/navbar.component.css
// module id = ./src/app/components/navbar/navbar.component.css
// module chunks = main